export const locale = {
  default: 'zh-TW',
};
